import {addPvNew, getUrlParams, isBase64Url} from '../../utils';

import {reportActionToRedies} from './utils';

import store from '../../store/index';
export function addImgUrlParams(list) {

    return list.map(item => {
        const separator = item.src.includes('?') ? '&' : '?';
        const isLowImg = isBase64Url(item.src);
        const src = isLowImg ? item.src : `${item.src}${separator}isFeedSwiper=1`;

        return {
            ...item,
            src
        };
    });
}

// 资源监控函数
export function newPerformanceObserver(callback) {
    if (!window.PerformanceObserver) {
        return;
    }
    // 创建一个 PerformanceObserver 实例
    const observer = new PerformanceObserver(list => {
        // 遍历性能条目
        list.getEntries().forEach(entry => {
            // 只关注资源类型的性能条目
            if (entry.entryType === 'resource') {
                callback(entry);
            }
        });
    });

    // 启动 PerformanceObserver，观察资源类型的性能条目
    observer.observe({entryTypes: ['resource']});
}
// 图片耗时统计
export function initImgMonitor() {
    newPerformanceObserver(entry => {
        // 过滤出轮播图图片资源
        if (entry.initiatorType === 'img') {
            if (entry.name.includes('isFeedSwiper=1')) {
                imgLoadBury(entry.name, entry.duration);
            }
        }
    });
}

// 图片加载耗时埋点
export function imgLoadBury(name, duration) {
    addPvNew(['NewMedia.microDetail.imgLoad'], {
        src: name.slice(0, -15),
        loadTime: duration
    });
}

// 接口耗时统计埋点
export function requestTimeBury(startTime, endTime, isComment, isSingle) {
    addPvNew(['NewMedia.microDetail.requestCost'], {
        requestStartTime: startTime,
        requestEndTime: endTime,
        requestCostTime: endTime - startTime,
        isCommentNote: isComment ? 1 : 0,
        // 是否是单篇笔记接口
        isSingle: isSingle ? 1 : 0
    });
}

// 携程加载耗时统计埋点
export function ctripBury(startTime, endTime, url, isPreload = false) {
    addPvNew(['NewMedia.microDetail.ctripLoad'], {
        startLoadTime: startTime,
        endLoadTime: endTime,
        ctripLoadTime: endTime - startTime,
        ctripUrl: url,
        isPreload: isPreload ? 1 : 0
    });
}

// 笔记来源source，取自url
const params = getUrlParams(location.href);
const {source = ''} = params || {};
const sourceFrom = source;

// 单篇笔记浏览最大的index
let sendBuryMaxIndex = 0;

// 单篇笔记浏览时长统计埋点
let sendBuryMap = new Map();
export const setBuryArr = params => {
    const {
        index = 0,
        leaveBury = false
    } = params || {};
    // 存储当前浏览最后一篇的index
    sendBuryMaxIndex = Math.max(sendBuryMaxIndex, Number(index));

    // 已经存入的数据
    const indexStr = 'i-' + index;
    const innerContent = sendBuryMap.get(indexStr);
    const mergeObj = {...innerContent, ...params};
    // 合并存入
    sendBuryMap.set('i-' + index, mergeObj);

    // 合并后的数据
    const {
        index: mIndex = 0,
        start_unique_id = '',
        end_unique_id = '',
        startTime = 0,
        endTime = 0,
        tpSource = '',
        levelOne = '',
        levelTwo = ''
    } = mergeObj || {};

    // 单篇浏览有效时间最大10分钟，预加载数据不携带unique_id信息，可能会存入空的start_unique_id
    const maxViewTime = 600000;
    if (startTime > 0
        && endTime > startTime
        && (endTime - startTime <= maxViewTime)
        && ((start_unique_id === end_unique_id && Number(mIndex) > 0) || (Number(mIndex) === 0 && end_unique_id !== ''))) {
        // 单篇浏览时长
        const singleViewTime = endTime - startTime;
        addPvNew(['MCEDse.singlebijiview.pt'], {
            rank: mIndex,
            unique_id: end_unique_id,
            source: sourceFrom,
            tp: tpSource,
            cost_time: singleViewTime,
            levelOne,
            levelTwo
        });
        // hasSend 表示是否已经埋点，如果是离开页面（leaveBury=true）这种非正常结束的埋点，不需要修改hasSend为true，这样同一篇会出现多次埋点，取最长的即可
        sendBuryMap.set('i-' + index, {...mergeObj, ...{hasSend: !leaveBury}});
    }
};

// 离开页面时，上报最后一篇的浏览时长
export function leavePageReport() {
    const maxIndex = 'i-' + sendBuryMaxIndex;
    const maxIndexData = sendBuryMap.get(maxIndex);
    const {index = '', start_unique_id = '', hasSend = false} = maxIndexData || {};
    if (hasSend || start_unique_id === '') {
        return;
    }
    setBuryArr(
        {
            index,
            end_unique_id: start_unique_id,
            endTime: Date.now(),
            leaveBury: true
        }
    );

}

// 微详情笔记浏览到底部埋点
export function microViewEndBury(params) {
    addPvNew(['MCEDse.NewMedia.detailspage.bottom.show'], params);
}

// 组件包版本埋点
export function componentVerBury() {
    const params = getUrlParams(location.href);
    // 组件包版本comVersion
    const {comVersion = ''} = params || {};

    addPvNew(['MCEDse.NewMedia.microComponent.ver.show'], {
        comVersion: comVersion
    });
}

// 笔记正文展开点击埋点
export function noteOpenClickBury(index) {
    const {state: {
        dataList: {requestTime = '', dataList = []},
        url: {
            source = '',
            abtest = '',
            uid: poi_uid = ''
        }
    }} = store;
    if (typeof index !== 'number' || index < 0 || index >= dataList.length) {
        return;
    }
    const {
        levelOne = '',
        levelTwo = '',
        unique_id = '',
        author: {
            tpSource = ''
        },
        burying = {}
    } = dataList[index];
    if (!unique_id) {
        return;
    }
    addPvNew(['MCDfeed.NewMedia.detailspage.Microcoopen.click'], {
        unique_id,
        user_behavior_sessionid: requestTime,
        source,
        tp: tpSource,
        uid: poi_uid,
        levelOne,
        levelTwo,
        note_index: index,
        abtest,
        ...burying
    });
}

// 轮播图横划埋点
export function swiperChangeBury(val, index, phoneInfo) {
    addPvNew(['NewMedia.detailspage.imgslide.click'], val);
    // 上报action
    reportActionToRedies({unique_id: val.unique_id}, index, 'slide_img', phoneInfo);
}

// btnlist 点赞埋点
export function btnListLikeBury(params) {
    addPvNew(['NewMedia.detailspage.likeBtn.click'], params);
}
// btn 收藏埋点
export function btnListCollectBury(params) {
    addPvNew(['NewMedia.detailspage.collectBtn.click'], params);
}
// btnlist 点击评论埋点
export function btnListBottomCommentBury(params) {
    addPvNew(['NewMedia.detailspage.bottomComment.click'], params);
}
// 评论展示埋点
export function btnListTextCommentBury(params) {
    addPvNew(['NewMedia.detailspage.textComment.show'], params);
}
// 投诉点击埋点
export function btnListFeedbackBury(params) {
    addPvNew(['MCEDse.NewMedia.barmore.click'], params);
}

// 单篇笔记埋点，包含首篇笔记埋点

export function showFeedBury(index, position = 'top') {
    const {state: {
        dataList: {dataList = [], requestTime = ''},
        cityId = '',
        url: {
            source = '',
            abtest = '',
            urlParams = {},
            uid: poi_uid = '',
            firstUnique_id = ''
        },
        phoneInfo = {}
    }} = store;
    const {
        initialSource = '',
        pushfrom = '',
        topic = '',
        origin_from = '',
        half_screen = 2 // 0-全屏，1-半屏
    } = urlParams || {};
    const typeMap = {
        'uigc_park': 'park',
        'uigc_trip': 'travel',
        'uigc_traffic': 'people'
    };
    const {
        levelOne = '', levelTwo = '', unique_id = '',
        strategyInfo = '',
        author: {
            subSource = '',
            tpSource: tpShowSource = '', // 页面展示埋点使用author下的tpSource字段
            contentSource = '',
            appId = '',
            isQmyj = 0,
            pushCategory = '',
            isQwzh = 0
        },
        data_type = 1, // 0-评论，1-笔记
        burying = {}
    } = dataList[index];
    let buryParams = {
        type: 'image',
        levelOne,
        levelTwo,
        source,
        unique_id,
        city_id: cityId,
        tp: tpShowSource,
        pmgc: subSource,
        // subSource对齐其他产品位参数名
        subSource,
        // 新增内容来源埋点
        contentSource,
        // 主feed来源参数
        initialSource: initialSource,
        mediasource: appId,
        note_style: 'Micro',
        strategy_info: strategyInfo,
        note_index: index,
        warningnote: Number(isQmyj) ? '1' : '0',
        authoritynote: Number(isQwzh) ? '1' : '0',
        pushcategory: pushCategory,
        abtest: abtest,
        pushfrom: pushfrom,
        topic: topic,
        content_type: typeMap[subSource] || '',
        origin_from: origin_from,
        pushywf: '',
        user_behavior_sessionid: requestTime,
        uid: poi_uid,
        is_comment: Number(data_type) === 1 ? 0 : 1,
        first_uniqueid: firstUnique_id,
        ...burying
    };
    if (half_screen !== 2) {
        buryParams.half_screen = half_screen;
    }
    const key = position === 'top' ? ['NewMedia.detailspage.PGshow'] : ['NewMedia.detailspage.new.PGshow'];
    addPvNew(key, buryParams);
    if (position === 'top') {
        const item = dataList[index];
        reportActionToRedies(item, index, 'show', phoneInfo);
    }
};